import api from './index'

/**
 * 获取用户列表
 * @param {*} data
 * @returns
 */
export const getUserList = (data) => {
  return api({ url: '/admin/user/list', data })
}

/**
 * 获取角色列表
 * @param {*} data
 * @returns
 */
export const getRoleList = (data) => {
  return api({ url: '/admin/role/lst', data })
}

/**
 * 获取用户详情
 * @param {*} data
 * @returns
 */
export const getUserDetail = (data) => {
  return api({ url: '/admin/user/detail', method: 'post', data })
}

/**
 * 新增或编辑用户
 * @param {*} data
 * @param {*} type
 * @returns
 */
export const addUser = (data, type) => {
  return api({ url: `/admin/user/${type}`, method: 'post', data })
}

/**
 * 删除用户
 * @param {*} data
 * @returns
 */
export const deleteUser = (data) => {
  return api({ url: '/admin/user/delete', method: 'post', data })
}

/**
 * 重置密码
 * @param {*} data
 * @returns
 */
export const resetPassword = (data) => {
  return api({ url: '/admin/user/reset', method: 'post', data })
}

/**
 * 删除角色
 * @param {*} data
 * @returns
 */
export const deleteRole = (data) => {
  return api({ url: '/admin/role/delete', method: 'post', data })
}

/**
 * 获取角色详情
 * @param {*} data
 * @returns
 */
export const getRoleDetail = (data) => {
  return api({ url: '/admin/role/detail', method: 'post', data })
}

/**
 * 添加或编辑角色
 * @param {*} data
 * @param {*} type
 * @returns
 */
export const addRole = (data, type) => {
  return api({ url: `/admin/role/${type}`, method: 'post', data })
}

/**
 * 获取账号信息
 * @returns
 */
export const getAccountInfo = () => {
  return api({ url: '/admin/user/getUserInfo' })
}
